import "../utility.css"
import "./01_hearingTestPage.css"

import img1 from "../../../assets/final/Images/03_ProcessPage/01_HeroSection_HeroImage.jpg"
import img2 from "../../../assets/final/Images/03_ProcessPage/02_ProcessSection_1.jpg"

import NavigationBar from "../../../components/01_navigationBar/01_navigationBar";
import Footer from "../../../components/02_footer/02_footer";

export default function HearingTest() {
    return (
        <div>
            <NavigationBar />
            <div className="HearingTestPage-HeroSection">
                <div className="HearingTestPage-HeroSection-Info">
                        <h1>Our Hearing Assessment Process</h1>
                        <p>
                            Understanding your hearing is the first step towards better communication and a better quality of life. At Easy Hear, every hearing assessment is conducted by experienced audiologists using advanced diagnostic equipment to ensure accurate results and personalized recommendations.
                        </p>
                </div>
                <img src={img1} alt="" />
            </div>
            <div className="HearingTestPage-ProcessSection">
                <div className="HearingTestPage-ProcessSection-Static">
                    <img src={img2} alt="" />
                    <h2>Our Promise</h2>
                    <p>At Easy Hear, we believe that better hearing starts with honest advice—not sales pressure.
                    <br /><br />
                    Every recommendation we make is based on your unique hearing needs, ensuring you receive a solution that helps you hear conversations more clearly, stay connected with loved ones, and enjoy a better quality of life.
                    </p>
                </div>
                <div className="HearingTestPage-ProcessSection-Scroller">
                    <div className="HearingTestPage-ProcessSection-Scroller-Card">
                        <span>Step 1</span>
                        <h2>Initial Consultation</h2>
                        <h3>
                            Every hearing journey begins with a conversation.
                        </h3>
                        <p>
                            Our audiologist takes the time to understand your hearing concerns, medical history, daily listening challenges, and any symptoms you may be experiencing. This helps us recommend the most suitable evaluation for your needs.
                        </p>
                    </div>
                    <div className="HearingTestPage-ProcessSection-Scroller-Card">
                        <span>Step 2</span>
                        <h2>Ear Examination</h2>
                        <h3>
                            Before testing your hearing, we carefully examine your ear canal and eardrum using an otoscope.
                        </h3>
                        <p>
                            This allows us to identify conditions such as earwax blockage, infections, inflammation, or any abnormalities that may affect your hearing. If needed, we'll guide you on the appropriate next steps before proceeding.
                        </p>
                    </div>
                    <div className="HearingTestPage-ProcessSection-Scroller-Card">
                        <span>Step 3</span>
                        <h2>Comprehensive Hearing Test</h2>
                        <p>
                            Once your ears have been examined, we perform a detailed hearing assessment in a professionally designed sound-treated room using advanced, regularly calibrated diagnostic equipment.
                            <br /><br />
                            Every hearing test at Easy Hear is carried out by experienced audiologists to ensure accurate and reliable results.
                        </p>
                        <h3>Your hearing assessment may include:</h3>
                        <ul>
                            <li>Pure Tone Audiometry (PTA)</li>
                            <li>Speech understanding assessment</li>
                            <li>Additional diagnostic tests (if required)</li>
                        </ul>
                    </div>
                    <div className="HearingTestPage-ProcessSection-Scroller-Card">
                        <span>Step 4</span>
                        <h2>Understanding Your Hearing Report</h2>
                        <p>
                            After your assessment, we carefully review your hearing results with you.
                            <br /><br />
                            We explain your audiogram in simple language so you clearly understand:
                        </p>
                        <ul>
                            <li>Degree of hearing loss</li>
                            <li>Type of hearing loss</li>
                            <li>Speech understanding ability</li>
                            <li>Everyday listening challenges</li>
                        </ul>
                        <p>Our goal is to ensure you leave with complete clarity—not confusion.</p>
                    </div>
                    <div className="HearingTestPage-ProcessSection-Scroller-Card">
                        <span>Step 5</span>
                        <h2>Personalized Hearing Aid Recommendations</h2>
                        <p>
                            No two people hear the same way.
                            <br /><br />
                            That's why we recommend hearing solutions based on your hearing results, lifestyle, communication needs, comfort preferences, and budget.
                            <br /><br />
                            Our focus is helping you hear conversations naturally—not simply making sounds louder.

                        </p>
                    </div>
                    <div className="HearingTestPage-ProcessSection-Scroller-Card">
                        <span>Step 6</span>
                        <h2>Comfort, Clarity & Ease of Use</h2>
                        <p>
                          The right hearing aid should fit seamlessly into your daily life.  
                        </p>
                        <h3>
                            We help you choose hearing devices that offer:
                        </h3>
                        <ul>
                            <li>Clear speech understanding</li>
                            <li>Natural sound quality</li>
                            <li>Better TV and phone listening</li>
                            <li>Reduced background noise</li>
                            <li>Comfortable all-day wear</li>
                            <li>Easy handling for senior citizens</li>
                            <li>Reliable long-term performance</li>
                        </ul>
                    </div>
                    <div className="HearingTestPage-ProcessSection-Scroller-Card">
                        <span>Step 7</span>
                        <h2>Hearing Aid Demonstration</h2>
                        <p>
                            Before making your decision, you'll have the opportunity to experience your recommended hearing aid during an in-clinic demonstration.
                            <br /><br />
                            This allows you to evaluate speech clarity, listening comfort, sound quality, and ease of communication before choosing your hearing solution.

                        </p>
                    </div>
                    <div className="HearingTestPage-ProcessSection-Scroller-Card">
                        <span>Step 8</span>
                        <h2>Final Hearing Aid Selection</h2>
                        <p>
                            Once you're comfortable with the recommended solution, we help you select the hearing aid that best matches your hearing needs, lifestyle, preferences, and budget.
                            <br /><br />
                            Our goal is to provide a hearing solution that delivers long-term comfort, confidence, and better hearing every day.

                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}